/**
 * Shared SVG progress-ring geometry. Four ring renderers (CircularCountdown,
 * NowCard, HabitRing, CompleteRing) previously each hand-rolled circumference
 * / dash-offset math with their own magic constants (53.4, 62.83) and sign
 * conventions — derive both values from here instead.
 *
 * Convention: pair with `transform="rotate(-90 cx cy)"` so progress starts at
 * 12 o'clock. A positive dash offset drawn with these values FILLS clockwise
 * as `progress` rises; negate the offset for a ring that DEPLETES clockwise
 * (the routine countdown).
 */
export function clamp01(n: number): number {
  if (Number.isNaN(n) || n < 0) return 0;
  if (n > 1) return 1;
  return n;
}

/** Circumference of an SVG circle of radius r — the stroke-dasharray value. */
export const ringCircumference = (radius: number): number => 2 * Math.PI * radius;

/** stroke-dashoffset leaving `progress` (0–1) of the ring drawn. */
export const ringDashOffset = (radius: number, progress: number): number =>
  ringCircumference(radius) * (1 - clamp01(progress));
